(function () {
  const config = window.WSMTracking || {};
  const retiredCourseHosts = new Set(['courses.excelmojo.com', 'in-courses.wallstreetmojo.com', 'courses.wallstreetmojo.in', 'courses.wallstreetmojo.com']);
  const configuredCourseHosts = (config.courseHosts || []).filter(function (host) {
    return !retiredCourseHosts.has(host);
  });
  const courseHosts = new Set(configuredCourseHosts);
  courseHosts.add('academy.wallstreetmojo.com');
  courseHosts.add('india.wallstreetmojo.com');
  const prepared = new WeakMap();
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  const placementRules = [
    ['header, .site-header, .wsm-landing-header', 'header_menu'],
    ['.mobile-drawer, .drawer-menu, .wsm-mobile-drawer, .mobile-menu-panel', 'mobile_menu'],
    ['.product-form, .sticky-card-wrap', 'product_page'],
    ['.product-card, .course-card, .wsm-v3dc106-card, [data-catalog-card]', 'product_card'],
    ['.featured-product, .hero-product, .wsm-v3dc2-elite, .wsm-v3dc106-featured-elite-card, .wsm-v3dc106-elite-card', 'hero_product'],
    ['.cart-drawer, .cart', 'cart_drawer'],
    ['.popup, .modal, .slide-in, .wsm-v1110a1-popup, .wsm-v1110a1-popup-overlay, [class*="popup"], [class*="modal"], [class*="slide-in"]', 'popup'],
    ['footer, .site-footer', 'footer']
  ];

  function clean(value, fallback) {
    return String(value || fallback || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80);
  }

  function textOf(element) {
    return String(element && element.textContent ? element.textContent : '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 120);
  }

  function urlFor(anchor) {
    const href = anchor && anchor.getAttribute('href');

    if (!href) return null;
    if (href.charAt(0) === '#' && href.indexOf('#wsm-dynamic-checkout') !== 0) return null;

    try {
      return new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function isSkippable(url) {
    return !url || ['mailto:', 'tel:', 'sms:', 'javascript:'].includes(url.protocol);
  }

  function isCourseUrl(url) {
    if (isSkippable(url)) return false;
    if (url.hash && url.hash.indexOf('#wsm-dynamic-checkout') === 0) return true;
    if (courseHosts.has(url.hostname)) return true;
    if (url.hostname !== window.location.hostname) return false;
    return /^\/products\//.test(url.pathname) ||
      /^\/cart\/add\b/.test(url.pathname) ||
      /^\/checkout\b/.test(url.pathname);
  }

  function placementFor(anchor) {
    for (const rule of placementRules) {
      if (anchor.closest(rule[0])) return rule[1];
    }
    return '';
  }

  function ctaIdFor(anchor, placement, url) {
    const productCard = anchor.closest('.product-card, .course-card, .wsm-v3dc106-card, [data-catalog-card]');
    if (productCard) {
      return clean(textOf(productCard.querySelector('h1, h2, h3, .product-title, .card__heading')), placement);
    }

    const productForm = anchor.closest('.product-form');
    if (productForm) {
      return clean(config.pageSlug || config.pageTitle, 'product_page');
    }

    if (url && (url.hash.indexOf('#wsm-dynamic-checkout') === 0 || /^\/cart\/add\b/.test(url.pathname) || /^\/checkout\b/.test(url.pathname))) {
      return clean(config.pageSlug || config.pageTitle || textOf(anchor), 'checkout_cta');
    }

    const popup = anchor.closest('.popup, .modal, .slide-in, .wsm-v1110a1-popup, .wsm-v1110a1-popup-overlay, [class*="popup"], [class*="modal"], [class*="slide-in"]');
    if (popup) {
      return clean(textOf(popup.querySelector('h1, h2, h3')), 'popup');
    }

    const path = url && url.pathname ? url.pathname.replace(/^\/+|\/+$/g, '').split('/').pop() : '';
    return clean(path || textOf(anchor), placement || 'link');
  }

  function contentValue(placement, ctaId) {
    return [
      clean(config.pageType, 'page'),
      clean(config.collection || config.pageSlug || config.pageTitle, 'uncategorized'),
      clean(placement, 'placement'),
      clean(ctaId, 'cta')
    ].filter(Boolean).join('__').slice(0, 150);
  }

  function addUtms(anchor) {
    const url = urlFor(anchor);
    if (!isCourseUrl(url)) return null;

    const placement = placementFor(anchor) || 'course_link';
    const ctaId = ctaIdFor(anchor, placement, url);

    if (url.hash && url.hash.indexOf('#wsm-dynamic-checkout') === 0) {
      return url;
    }

    if (!url.searchParams.has('utm_source')) url.searchParams.set('utm_source', 'wallstreetmojo');
    if (!url.searchParams.has('utm_medium')) url.searchParams.set('utm_medium', clean(placement, 'website_click'));
    if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', clean(ctaId, 'course_click'));
    if (!url.searchParams.has('utm_content')) url.searchParams.set('utm_content', contentValue(placement, ctaId));

    anchor.href = url.toString();
    return url;
  }

  function eventPayload(anchor, url) {
    const placement = placementFor(anchor);
    const courseClick = isCourseUrl(url);
    const ctaId = ctaIdFor(anchor, placement, url);

    return {
      event: courseClick ? 'wsm_course_click' : 'wsm_navigation_click',
      wsm_placement: placement || 'unclassified',
      wsm_cta_id: ctaId,
      wsm_button_text: textOf(anchor),
      wsm_destination_url: url ? url.toString() : '',
      wsm_is_course_link: courseClick ? 'yes' : 'no',
      wsm_page_type: config.pageType || '',
      wsm_page_id: config.pageId || '',
      wsm_page_slug: config.pageSlug || '',
      wsm_page_title: config.pageTitle || document.title,
      wsm_collection: config.collection || ''
    };
  }

  function sendEvent(payload) {
    if (!payload || !payload.wsm_placement || payload.wsm_placement === 'unclassified') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      const eventName = payload.event;
      const fields = Object.assign({}, payload);
      delete fields.event;
      window.gtag('event', eventName, fields);
    }
  }

  function readStored() {
    try {
      return JSON.parse(localStorage.getItem('wsm_attribution') || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeStored(data) {
    try {
      localStorage.setItem('wsm_attribution', JSON.stringify(data));
    } catch (error) {}
  }

  function captureIncomingUtms() {
    const params = new URLSearchParams(window.location.search);
    const stored = readStored();
    const current = {};

    UTM_KEYS.forEach(function (key) {
      if (params.has(key)) current[key] = params.get(key);
    });

    if (!stored.original_landing_page) {
      stored.original_landing_page = window.location.href;
    }

    stored.last_landing_page = window.location.href;

    if (Object.keys(current).length) {
      stored.latest_touch = Object.assign({}, stored.latest_touch || {}, current);

      if (!stored.first_touch) {
        stored.first_touch = current;
      }
    }

    writeStored(stored);
    return stored;
  }

  function flattenAttribution(stored) {
    const latest = stored.latest_touch || {};
    const first = stored.first_touch || {};

    return {
      utm_source: latest.utm_source || first.utm_source || '',
      utm_medium: latest.utm_medium || first.utm_medium || '',
      utm_campaign: latest.utm_campaign || first.utm_campaign || '',
      utm_content: latest.utm_content || first.utm_content || '',
      utm_term: latest.utm_term || first.utm_term || '',
      first_utm_source: first.utm_source || '',
      first_utm_medium: first.utm_medium || '',
      first_utm_campaign: first.utm_campaign || '',
      first_utm_content: first.utm_content || '',
      first_utm_term: first.utm_term || '',
      original_landing_page: stored.original_landing_page || '',
      last_landing_page: stored.last_landing_page || window.location.href
    };
  }

  function updateCartAttributes(stored) {
    if (!stored) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: flattenAttribution(stored) })
    }).catch(function () {});
  }

  function prepare(anchor) {
    if (!anchor || prepared.has(anchor)) return prepared.get(anchor) || null;

    const originalUrl = urlFor(anchor);
    if (isSkippable(originalUrl)) return null;

    const placement = placementFor(anchor);
    if (!placement) return null;

    const updatedUrl = addUtms(anchor) || urlFor(anchor);
    const payload = eventPayload(anchor, updatedUrl);

    prepared.set(anchor, payload);
    return payload;
  }

  const stored = captureIncomingUtms();
  updateCartAttributes(stored);

  document.addEventListener('pointerdown', function (event) {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) prepare(anchor);
  }, true);

  document.addEventListener('focusin', function (event) {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) prepare(anchor);
  }, true);

  document.addEventListener('click', function (event) {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;

    const payload = prepare(anchor);
    if (payload) sendEvent(payload);
  }, true);
})();
